import React, { Fragment } from 'react'
import { Form, Input, Typography } from 'antd'
import PropTypes from 'prop-types'

const inlineLayout = {
  labelCol: { xs: { span: 24 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, lg: { span: 12 } },
}

const boaCompraLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    <span style={{ color: '#d60202' }}>*</span>4. Informe o seu e-mail BoaCompra
    para transferência dos créditos:
  </Typography.Text>
)

export const BoaCompra = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Form.Item name='boaCompraEmail' label={boaCompraLabel} {...inlineLayout}>
        <Input
          type='text'
          name='boaCompraEmail'
          value={answers?.boaCompraEmail}
          onChange={handleChange('boaCompraEmail')}
          required
        />
      </Form.Item>
    </Fragment>
  )
}

BoaCompra.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
